<template>
    <div @pointerenter="showLogo" @pointerleave="hideLogo" class="h-8 w-8 md:h-14 md:w-14 flex items-center">
        <NuxtLink :to="localePath('/')">
            <div
                class="flex flex-row gap-0"
            >
                <svg
                    width="40px"
                    height="40px"
                    viewBox="0 0 42 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="transition-colors fill-dark-blue"
                    :class="{'fill-white': siteStore.header_icon_color === 'light', 'fill-dark-blue': siteStore.header_icon_color === 'dark'}"
                >
                    <path
                        d="M25.4371 0.0228311L20.9462 7.99087L16.1468 0.0456621L0 0.0228311L13.587 22.3858C13.7127 22.5913 13.8156 22.9452 13.8156 23.1849V39.9543H28.0426V23.1849C28.0426 22.9452 28.1454 22.5913 28.2711 22.3858L41.5839 0L25.4371 0.0228311Z"
                        fill=""
                    />
                </svg>
                <svg width="15" height="40" viewBox="0 0 15 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2 pointer-events-none opacity-0 transition-all logo-letter delay-0 ease-in-out rotate-12" :class="{'opacity-100 !rotate-0': show_logo_long, 'fill-white': siteStore.header_icon_color === 'light', 'fill-dark-blue': siteStore.header_icon_color === 'dark'}">
                    <path d="M0 0V29.4977V33.847V39.9886H14.0213V32.0662V26.8037V0H0Z"/>
                </svg>
                <svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2 pointer-events-none opacity-0 transition-all logo-letter delay-50 ease-in-out rotate-12" :class="{'opacity-100 !rotate-0': show_logo_long, 'fill-white': siteStore.header_icon_color === 'light', 'fill-dark-blue': siteStore.header_icon_color === 'dark'}">
                    <path
                        d="M33.4477 8.21918C32.6363 6.38128 31.505 4.8516 30.0538 3.63014C28.6025 2.40868 26.8884 1.49543 24.9001 0.901826C22.9117 0.296804 18.855 0.022831 18.855 0.022831C18.6151 0.0114155 18.2265 0 17.998 0H0V40H14.0099L14.0213 27.9566H21.449C23.4716 27.9566 25.3 27.6484 26.9455 27.032C28.5911 26.4155 29.9852 25.5251 31.1165 24.3836C32.2478 23.242 33.1277 21.8493 33.7448 20.2283C34.3619 18.5959 34.6818 16.758 34.6818 14.7032C34.6818 12.226 34.2704 10.0685 33.4591 8.23059L33.4477 8.21918Z"
                    />
                </svg>
                <svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2 pointer-events-none opacity-0 transition-all logo-letter delay-100 ease-in-out rotate-12" :class="{'opacity-100 !rotate-0': show_logo_long, 'fill-white': siteStore.header_icon_color === 'light', 'fill-dark-blue': siteStore.header_icon_color === 'dark'}">
                    <path
                        d="M33.4477 8.21918C32.6363 6.38128 31.505 4.8516 30.0538 3.63014C28.6025 2.40868 26.8884 1.49543 24.9001 0.901826C22.9117 0.296804 18.855 0.022831 18.855 0.022831C18.6151 0.0114155 18.2265 0 17.998 0H0V40H14.0099L14.0213 27.9566H21.449C23.4716 27.9566 25.3 27.6484 26.9455 27.032C28.5911 26.4155 29.9852 25.5251 31.1165 24.3836C32.2478 23.242 33.1277 21.8493 33.7448 20.2283C34.3619 18.5959 34.6818 16.758 34.6818 14.7032C34.6818 12.226 34.2704 10.0685 33.4591 8.23059L33.4477 8.21918Z"
                    />
                </svg>
            </div>

        </NuxtLink>
    </div>
</template>

<script lang="ts" setup>
const show_logo_long = ref(false)
const siteStore = useSiteStore()
const localePath = useLocalePath()

const showLogo = (event: PointerEvent) => {
    if (event.pointerType === 'mouse') {
        show_logo_long.value = true
    }
}

const hideLogo = () => {
    show_logo_long.value = false
}

</script>

<style lang="scss" scoped>
@for $i from 1 through 10 {
    .logo-letter:nth-child(#{$i}n) {
        animation-delay: #{$i * 0.5}s;
    }
}
</style>
